import React from 'react';
import Card from './Card';
import SectionHeader from './SectionHeader';

interface SectionContainerProps {
    title: string;
    children: React.ReactNode;
    headerExtra?: React.ReactNode;
    className?: string;
    cardClassName?: string;
    cardBackgroundClassName?: string;
}

const SectionContainer: React.FC<SectionContainerProps> = ({
    title,
    children,
    headerExtra,
    className,
    cardClassName = 'p-6',
    cardBackgroundClassName,
}) => {
    return (
        <section className={`space-y-4 w-full min-w-0 ${className}`}>
            <div className="flex justify-between items-center">
                <SectionHeader title={title} />
                {headerExtra}
            </div>
            <Card
                variant="elevated"
                rounded="2xl"
                className={`${cardClassName}`}
                backgroundClassName={cardBackgroundClassName}>
                {children}
            </Card>
        </section>
    );
};

export default SectionContainer;
